export const Arkus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 22H7.40541L8.48649 19.2152H15.5135L16.8649 22H22L13.6216 2H10.9189L2 22ZM13.6216 14.6582L12 11.1139L10.3784 14.6582H13.6216Z"
      fill="#53599F"
    />
    <path
      d="M4.97297 12.1266V2H9.2973V2.75949L4.97297 12.1266Z"
      fill="#ED9E3D"
    />
  </svg>
);
